import { useCallback } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { useDispatch } from "react-redux";

import { showSuccessToast } from "app/actions/toast_actions";

import { useIndustryTransitionSendEmailMutation } from "../queries/useIndustryTransitionSendEmailMutation";
import industryTrackingService from "../services/tracking/trackingService";
import { useIndustryTransitionModalStore } from "../store/useIndustryTransitionModalStore";
import { industryTransitionKeys } from "../utils/i18n";

export const useImpactReportContactUs = () => {
    const dispatch = useDispatch();
    const { translate } = useTranslate();
    const hasSentContactEmail = useIndustryTransitionModalStore((state) => state.hasSentContactEmail);
    const markContactEmailSent = useIndustryTransitionModalStore((state) => state.markContactEmailSent);
    const { mutate } = useIndustryTransitionSendEmailMutation();

    const handleContactUs = useCallback(() => {
        if (useIndustryTransitionModalStore.getState().hasSentContactEmail) {
            return;
        }

        markContactEmailSent();
        industryTrackingService.trackImpactReportContactUs();
        dispatch(showSuccessToast(translate(industryTransitionKeys.reportContactUsToast)));
        mutate();
    }, [dispatch, markContactEmailSent, mutate, translate]);

    return {
        showContactUs: !hasSentContactEmail,
        handleContactUs,
    };
};
